import { FieldProps, getIn } from 'formik';
import { Select, SelectProps } from '@lifeomic/chroma-react/components/Select';
import React from 'react';

interface FormikSelectProps extends FieldProps, SelectProps {}

export const FormikSelect: React.FC<FormikSelectProps> = ({
  className,
  children,
  label,
  form: { touched, errors, setFieldValue },
  field,
  ...rootProps
}) => {
  const handleChange = (value: string) => {
    setFieldValue(field?.name, value, true);
  };

  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;

  return (
    <Select
      className={className}
      label={label}
      onChange={handleChange}
      value={field.value}
      hasError={showError}
      errorMessage={showError && fieldError}
      {...rootProps}
    >
      {children}
    </Select>
  );
};
